module.exports = __webpack_public_path__ + "static/media/hets-logo.d1da5a81.png";